module.exports = __webpack_public_path__ + "img/a-2.4190587e.jpg";